import type { ContextProps } from "@keepoinc/site-page-react-component";
import { useTranslation } from "react-i18next";

import constants from "../../constants";
import { keepoLanguageOf } from "../../services/i18ln/languages";

export const useSitePageContextProps = (): ContextProps => {
  const { i18n } = useTranslation();
  // The Keepo's own texts come in the language it's published in (Portuguese or English, see keepoLanguageOf), not the
  // editor's: the preview shows what the page will say
  const keepoLanguage = keepoLanguageOf(i18n.language);
  const t = i18n.getFixedT(keepoLanguage);

  return {
    footer: {
      credits: t("pages.editor.preview.sections.keepoFooter.credits"),
    },
    form: {
      defaultSuccessMessage: t("pages.editor.form.form.successMessage.defaultValue"),
      fields: {
        name: t("pages.editor.form.form.fields.name"),
        email: t("pages.editor.form.form.fields.email"),
        phone: t("pages.editor.form.form.fields.phone"),
        message: t("pages.editor.form.form.fields.message"),
      },
      invalid: t("pages.editor.form.form.invalidSubmitForm"),
      formVersion: 2,
      messages: {
        required: t("pages.editor.form.form.messages.required"),
        invalidEmail: t("pages.editor.form.form.messages.invalidEmail"),
        invalidPhone: t("pages.editor.form.form.messages.invalidPhone"),
        invalidDocument: t("pages.editor.form.form.messages.invalidDocument"),
        invalidDate: t("pages.editor.form.form.messages.invalidDate"),
        selectPlaceholder: t("pages.editor.form.form.messages.selectPlaceholder"),
        submitError: t("pages.editor.form.form.messages.submitError"),
        accessLink: t("pages.editor.form.form.messages.accessLink"),
      },
    },
    hostSite: constants.site as string,
    hostApi: constants.api as string,
    finalSite: { lang: keepoLanguage === "pt" ? "pt-BR" : "en-US" },
  };
};
